import React from "react";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {ImHtmlFive} from 'react-icons/im';
import {SiIntel} from 'react-icons/si';
import {GiCyberEye} from 'react-icons/gi'
import {SiHackclub} from 'react-icons/si';
import logo from '../assets/img/logo.png';


const workIcon = {
  icon: <SiIntel />,
  iconStyle: { background: '#ff7a59', color: '#fff'}
};
const orisonIcon = {
  icon: <img src={logo} alt="" />,
  iconStyle: { background: '#ff7a59', color: '#fff' , size:'1.5rem' }
};
const hackIcon = {
  icon: <SiHackclub/>,
  iconStyle: { background: '#ff7a59', color: '#fff' }
};

const cyscomIcon = {
  icon: <GiCyberEye/>,
  iconStyle: { background: '#ff7a59', color: '#fff' }
};



function experience() {
  const timeline = [
    { icon: workIcon, date: "May'24 - present", title: 'Software Engineer Intern', subtitle: 'MediaLogic Pvt Ltd', desc: 'Machine Learning, Data Science, Full-Stack Development '},
    { icon: workIcon, date: "Nov'23 - Jan'24", title: 'Developer Advocate Intern', subtitle: 'OpenWeaver', desc: 'Product Management'},
    { icon: workIcon, date: "Jul'23 - Oct'23", title: 'AI Engineer', subtitle: 'Simulated Internship program , Intel', desc: 'Machine Learning, Data Science, Web Scraping, APIs, Computer Vision' },
    { icon: orisonIcon, date: "Sept'23 - Oct'23", title: 'Full-Stack Developer', subtitle: 'Orison Software Solutions', desc: 'React JS, HTML, CSS, JavaScript, MongoDB, Node JS' },
    { icon: hackIcon, date: '2021 - 2023', title: 'Full-Stack Developer', subtitle: 'HackClub , VIT Chennai', desc: 'React JS, Next, HTML, CSS, JavaScript, MongoDB, Node JS' },
    { icon: cyscomIcon, date: '2021 - 2023', title: 'Front-end developer and Blogger', subtitle: 'CYSCOM , VIT Chennai', desc: 'React JS, HTML, CSS, JavaScript, User Experience, Content Writing' },
  ];

  return (
    <section id="experience">
      <h5>What experience do I have</h5>
      <h2>My Experience</h2>
      <VerticalTimeline lineColor='#db880b'>
        {timeline.map((t, i) => {
          const contentStyle = i%2 === 0 ? { background: '#ff7a59', color: 'black' , fontSize: '1.4rem' } : { background: '#db880b', color: 'white' , fontSize: '1.4rem' };
          const arrowStyle = i%2 === 0 ? { borderRight: '7px solid  #fff' } : { borderRight: '7px solid  #fff' };
          

          return <VerticalTimelineElement
            key={i}
            className="vertical-timeline-element--work"
            contentStyle={contentStyle}
            contentArrowStyle={arrowStyle}
            {...t.icon}
          >
            {t.title ? <React.Fragment>
              <h3 className="vertical-timeline-element-title">{t.title}</h3>
              {t.subtitle && <h4 className="vertical-timeline-element-subtitle">{t.subtitle}</h4>}
              {t.date && <p style={{fontSize: "1.2rem"}}>{t.date}</p>}
              {t.desc && <p style={{fontSize: "1.2rem"}}>{t.desc}</p>}
            </React.Fragment> : undefined}
          </VerticalTimelineElement>
        })}
      </VerticalTimeline>
    </section>
  );
}

export default experience;